import React, { Fragment, useEffect, useState } from "react";
import { Step, Stepper } from "react-form-stepper";
import { useForm } from "react-hook-form";
import StepWizard from "react-step-wizard";
import { translate } from "react-switch-lang";
import { toast } from "react-toastify";
import { SupportVideoDto } from "../../../models/supportVideoDto";
import { useHttpClient } from "../../../security/hooks/axiosProvider";
import StepOne from "./step-one/stepOne";
import StepTwo from "./step-two/stepTwo";
const AddSupport = props => {
  toast.configure();
  const httpClient = useHttpClient(true);
  let custom = {
    enterRight: "transition: 1s linear;",
    enterLeft: "transition:left 1s linear;",
    exitRight: "transition:left 1s linear;",
    exitLeft: "transition:left 1s linear;",
  };
  const path = "/Mediatheque/image/";
  const [, setIsFomrValid] = useState(false);
  const [isOnUpdate, setisOnUpdate] = useState(false);
  const [selectedSupport, setSelectedSupport] = useState<any>(null);
  const [, setIsShowDropZone] = useState(true);
  const [activeStep, setActiveStep] = useState(0);
  const [supportVideoDto, setSupportVideoDto] = useState(new SupportVideoDto());
  const [, setStepWizard] = useState(null);
  const [link, setLink] = useState("");
  const [isShowZone, setIsShowZone] = useState(true);
  const { setValue } = useForm({
    mode: "onChange",
    defaultValues: {
      dateSupport: props?.support?.dateSupport ? props.support.dateSupport : "",
      title: props.support?.title ? props.support.title : "",
      link: props.support?.link ? props.support.link : "",
      language: props.support?.language ? props.support.language : "",
      videoTypeId: props.support?.videoTypeId ? props.support.videoTypeId : 0,
      listThematic: props.support?.listThematic ? props.support.listThematic : [],
      listCountry: props.support?.listCountry ? props.support.listCountry : [],
    },
  });
  useEffect(() => {
    if (props.support) {
      setIsFomrValid(true);
      setisOnUpdate(true);
      if (props.support.urlSupport) {
        setIsShowDropZone(false);
      }
      setValue("dateSupport", props.support?.dateSupport);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [httpClient]);

  const onSubmit = data => {
    props.resetAllFieldSearch();
    if (link !== "" && link !== null) {
      data.link = link;
    }
    if (!isOnUpdate) {
      let formData = new FormData();
      data.categoryId = props.categoryId;
      if (selectedSupport) {
        formData = new FormData();
        formData.append("file", selectedSupport);
        httpClient.current
          ?.post(`/support/files?path=${path}`, formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
          .then(response => {
            data.pathSupport = response.data;
            httpClient.current?.post("/support_video", data).then(response => {
              toast.success(props.t("message_toastr_add_pdf"), {
                position: toast.POSITION.TOP_RIGHT,
                autoClose: 5000,
              });
              props.getListSupport();
              props.closeToggle();
            });
          });
      } else {
        httpClient.current?.post("/support_video", data).then(response => {
          toast.success(props.t("message_toastr_add_pdf"), {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 5000,
          });
          props.getListSupport();
          props.closeToggle();
        });
      }
    } else {
      hanldeUpdateSupport(data);
    }
  };

  const hanldeUpdateSupport = support => {
    if (link !== "" && link !== null) {
      support.link = link;
    } else {
      support.link = props.support.link;
    }
    support.supportId = props.support.supportId;
    support.pathSupport = props.support.pathSupport;
    support.urlSupport = props.support.urlSupport;
    support.categoryId = props.support.categoryId;
    support.supportVideoESId = props.support.supportVideoESId;
    support.urlSupport = props.support.urlSupport;
    let formData = new FormData();
    if (selectedSupport) {
      formData = new FormData();
      formData.append("file", selectedSupport);
      httpClient.current
        ?.post(`/support/files?path=${path}`, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then(response => {
          support.pathSupport = response.data;
          httpClient.current?.put("/support_video", support).then(response => {
            props.getListSupport();
            toast.success(props.t("message_toastr_update"), {
              position: toast.POSITION.TOP_RIGHT,
              autoClose: 5000,
            });
            props.getListSupport();
            props.closeToggle();
          });
        });
    } else {
      if (isShowZone) {
        support.pathSupport = "";
        support.urlSupport = "";
      } else {
        support.pathSupport = props.support.pathSupport;
        support.urlSupport = props.support.urlSupport;
      }
      httpClient.current?.put("/support_video", support).then(response => {
        props.closeToggle();
        toast.success(props.t("message_toastr_update"), {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 5000,
        });
        props.getListSupport();
      });
    }
  };
  const assignStepWizard = instance => {
    setStepWizard(instance);
  };
  const handleStepChange = e => {
    setActiveStep(e.activeStep - 1);
  };
  const assignSupport = val => {
    setSupportVideoDto(user => ({
      ...user,
      ...val,
    }));
  };
  const lastStep = () => {
    onSubmit(supportVideoDto);
  };
  return (
    <Fragment>
      <Stepper className={"p-0"} activeStep={activeStep}>
        <Step label={props.t("step_info")} />
        <Step label={props.t("step_attachements")} />
      </Stepper>
      <StepWizard transitions={custom} instance={assignStepWizard} onStepChange={handleStepChange}>
        <StepOne close={props.closeToggle} support={props.support} userCallback={assignSupport} />
        <StepTwo
          setSelectedSupport={setSelectedSupport}
          close={props.closeToggle}
          element={supportVideoDto}
          setSupportVideoDto={setSupportVideoDto}
          last={lastStep}
          setIsShowZone={setIsShowZone}
          setLink={setLink}
          support={props.support}
          userCallback={assignSupport}
        />
      </StepWizard>
    </Fragment>
  );
};

export default translate(AddSupport);
